<template>
  <section class="mt-3 mb-3">
    <b-card title="Ajouter un mapping">
      <b-card-body>
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton-table
              :rows="5"
              :columns="3"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </template>

          <template v-if="categoriesLegacy">
            <div class="d-inline-flex align-items-center">
              <span>
                Catégorie Greenweez : {{ categoriesLegacy["name"] }}
              </span>

              <button
                type="button"
                class="close ml-1"
                aria-label="Close"
                @click="
                  categoriesLegacy = null;
                  attributeMirakl = null;
                  valueMirakl = null;
                "
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <b-form-group v-if="!attributeMirakl">
              <gwzAutoComplete
                input-id="search-attribute"
                :http="httpMiraklAttributes"
                input-label="Attribut"
                labelName="label"
                queryParamName="label"
                nameEndpoint="listMiraklAttributesTypeList"
                placeholder="Rechercher un Attribut"
                @response="addAttribute"
                key="search-attribute"
              ></gwzAutoComplete>
            </b-form-group>
            <b-form-group v-else>
              <div class="d-inline-flex align-items-center">
                <span
                  >Attribut sélectionné : {{ attributeMirakl["label"] }}</span
                >
                <button
                  type="button"
                  class="close ml-1"
                  aria-label="Close"
                  @click="
                    attributeMirakl = null;
                    valueMirakl = null;
                  "
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </b-form-group>

            <div v-if="showValuesInput">
              <label for="values-input">Valeur de l'attribut</label>
              <b-form-select
                id="values-input"
                v-model="valueMirakl"
                class="mb-3"
                :options="valueOptions"
              >
              </b-form-select>
            </div>

            <div
              class="text-right"
              v-if="
                (categoriesLegacy && attributeMirakl && valueMirakl) ||
                  (categoriesLegacy && !attributeMirakl && !valueMirakl)
              "
            >
              <gwz-button submitButtonText="Ajouter" @click="submitMapping" />
            </div>
          </template>

          <template v-else>
            <b-form-group>
              <gwzAutoComplete
                input-id="search-legacy-categories"
                :http="httpMiraklCategorie"
                input-label="Catégorie Greenweez"
                labelName="name"
                queryParamName="name"
                nameEndpoint="listLegacyCategories"
                placeholder="Rechercher une catégorie Greenweez"
                @response="addLegacyCategory"
                aria-describedby="legacy-category-input-live-feedback"
                key="search-category"
                required
              ></gwzAutoComplete>
            </b-form-group>
          </template>
        </b-skeleton-wrapper>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import GwzButton from "@/components/gwzButton";
import gwzAutoComplete from "@/components/gwzAutoComplete";
import { mapGetters } from "vuex";

export default {
  name: "AddMapping",
  props: {
    categoryMirakl: {
      type: Object,
      required: true
    }
  },
  components: {
    GwzButton,
    gwzAutoComplete
  },
  data() {
    return {
      required: false,
      categoriesLegacy: null,
      attributeMirakl: null,
      valueMirakl: null,
      valueOptions: [],
      attributeOptions: [],
      httpMiraklCategorie: this.$gwzApi.service("categories"),
      httpMiraklAttributes: this.$gwzApi.service("attributes"),
      httpMiraklValues: this.$gwzApi.service("values")
    };
  },
  computed: {
    ...mapGetters(["isLoading"]),
    categoriesMirakl() {
      return this.categoryMirakl["@id"];
    },
    showValuesInput() {
      return (
        this.attributeMirakl?.typeParameters?.split("|")[0] === "LIST_CODE"
      );
    }
  },
  methods: {
    async submitMapping() {
      let mapping = {
        miraklCategory: this.categoryMirakl?.["@id"],
        legacyCategory: this.categoriesLegacy?.["@id"]
      };

      if (
        this.attributeMirakl &&
        this.attributeMirakl["@id"] &&
        this.valueMirakl
      ) {
        mapping = {
          ...mapping,
          miraklAttribute: this.attributeMirakl["@id"],
          miraklValue: this.valueMirakl
        };
      }

      await this.$store.dispatch("mapping/addCategoryMapping", mapping);
      await this.$emit("reload");

      this.categoriesLegacy = null;
      this.attributeMirakl = null;
      this.valueMirakl = null;
    },
    addLegacyCategory(legacyCategory) {
      this.categoriesLegacy = legacyCategory;
    },

    addAttribute(attribute) {
      // Check if attribute is of type list
      this.attributeMirakl = attribute;

      const typeParameters = attribute.typeParameters;
      const type = typeParameters?.split("|")[0];

      if (type == "LIST_CODE") {
        const listCode = typeParameters?.split("|")[1];
        this.$gwzApi
          .service("values")
          .listMiraklValues({ listCode })
          .then((res) => {
            // Build array for bootstrap-vue datalist component

            this.valueOptions = res.data["hydra:member"].map((value) => {
              return { text: value["valueLabel"], value: value["@id"] };
            });
          });
      }
    }
  }
};
</script>

<style scoped></style>
